import { useRouteMatch } from "react-router-dom";
import { TestGrid } from "./pages/TestGrid/TestGrid";

export function UserPage() {
  const match = useRouteMatch<{ userId: string; testId: string }>();

  return <TestGrid userId={match.params.userId} />;
}
